<script setup lang="ts">
import type { Branches } from "~/types/directus-collections.d.ts";

const props = defineProps<{
  branch: Branches;
}>();

const parsedDescription = ref<string | null>(null);
const memberCount = ref<number | null>(null);

if (props.branch.description) {
  // Remove HTML tags from description
  parsedDescription.value = props.branch.description.replace(/<\/?[^>]+(>|$)/g, "");

  // Trim description to 150 characters
  if (parsedDescription.value.length > 150) {
    parsedDescription.value = parsedDescription.value.slice(0, 150) + "[...]";
  }
}

if (props.branch.branch_members_count) {
  memberCount.value = props.branch.branch_members_count;
}
</script>

<template>
  <div class="space-y-4 rounded-lg bg-white px-12 py-10">
    <div class="flex flex-col items-start justify-between gap-4 md:flex-row">
      <NuxtLink :to="{ name: 'groups-slug', params: { slug: branch.slug } }">
        <h3 class="text-2xl">{{ branch.title }}</h3>
      </NuxtLink>
      <div class="shrink-0 rounded-md bg-primary p-2 text-white">{{ branch.category }} - {{ memberCount }} Members</div>
    </div>
    <p class="text-lg">{{ parsedDescription }}</p>
    <div class="flex flex-wrap items-center gap-4 pt-4">
      <CommonButtonNuxtLink class="grow" :to="{ name: 'groups-slug', params: { slug: branch.slug } }">Group Details</CommonButtonNuxtLink>
      <CommonButtonNuxtLink
        v-if="branch.accept_donation && branch.stripe_id"
        class="grow"
        icon="fa-solid fa-hand-holding-dollar"
        btn-style="secondary"
        btn-hover-style="primary"
        :to="{ name: 'groups-slug', params: { slug: branch.slug } }"
        >Donate</CommonButtonNuxtLink
      >
    </div>
  </div>
</template>
